import { apiCall } from "../../services/api-service";

export const getCountApi = async (params) => {
  try {
    const response = await apiCall("GET", "dashboard/count", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getMonthTripApi = async (params) => {
  try {
    const response = await apiCall("GET", "dashboard/trip_month", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getTotalCostApi = async (params) => {
  try {
    const response = await apiCall("GET", "dashboard/cost_month", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getTripsOverviewApi = async (params) => {
  try {
    const response = await apiCall("GET", "dashboard/trips_overview", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getVehicleOverviewApi = async (params) => {
  try {
    const response = await apiCall("GET", "dashboard/vehicle_overview", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getCompleteOverviewApi = async (params) => {
  try {
    const response = await apiCall("GET", "dashboard/trip_completion_overview", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getOverallCostApi = async (params) => {
  try {
    const response = await apiCall("GET", "dashboard/categorycost", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getVendorBasedTripApi = async (params) => {
  try {
    const response = await apiCall("GET", "dashboard/vendor_based", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getTripsApi = async (params) => {
  try {
    const response = await apiCall("GET", "get_trips", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching trips:", err);
  } finally {
  }
};
